import React from 'react'
import Page from '../components/Page'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Nav, NavItem, NavLink, TabContent, TabPane, Table, Modal, ModalBody, ModalFooter, ModalHeader, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from 'axios'
import StorageService from '../services/StorageService'
import { MdCameraAlt, MdFace, MdDone, MdClear, MdCreate } from 'react-icons/md'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import PosUserForm from '../components/PosUserForm'
import PosGlobalUser from '../components/PosGlobalUser'
import PosUserGroup from '../components/PosUserGroup'
import { getProfile, getProfile_v2 } from '../utils/dropdownlist'
import { BsPlusSquareFill } from 'react-icons/bs'
import { IconContext } from 'react-icons/lib'
import classnames from 'classnames'
import Select from 'react-select'

class PosSupplierDetailPage extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      selectedData: '',
      selectedId: '',
      isGlobal: true,
      isEdit: false,
      dataList: [],
      subDataList: [],
    }
  }

  //   toggle = (action, id) => () => {
  //     let obj = {}

  //     if (id !== undefined || id !== null) {
  //       obj = this.state.userList.find(e => e.profile_id === id)
  //     }

  //     return this.setState({
  //       modal: !this.state.modal,
  //       isEdit: id != undefined || (id != null && action == 'EDIT') ? true : false,
  //       userId: id != undefined || (id != null && action == 'EDIT') ? id : '',
  //       email: id != undefined || (id != null && action == 'EDIT') ? obj.email : '',
  //       name: id != undefined || (id != null && action == 'EDIT') ? obj.name : '',
  //       contact: id != undefined || (id != null && action == 'EDIT') ? obj.contact : '',
  //     })
  //   }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  getData = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      id: this.props.match.params.id,
    }

    axios
      .post(url + ':3002/v1/product/supplier/detail', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.setState({ name: result.data.name, address: result.data.address, contact_person: result.data.contact_person, contact_no: result.data.contact_no, email: result.data.email, subDataList: result.data.products })
      })
      .catch(error => {
        alert(error)
      })
  }

  componentDidMount() {
    this.getData()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }
    return (
      <Page
        className="Userpage"
        title="Supplier Detail"
        breadcrumbs={[
          { name: 'Product', active: false, path: '/posproduct' },
          { name: 'Supplier', active: true, path: '/posproduct' },
        ]}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />

        <>
          <Row>
            <Col xl={12} lg={12} md={12}>
              <Card className="ps-card-display">
                <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">Supplier Information</CardHeader>
                <CardBody>
                  <Row form>
                    <Col lg={4}>
                      <label>Name</label>
                      <p>{this.state.name}</p>
                    </Col>
                    <Col lg={4}>
                      <label>Address</label>
                      <p>{this.state.address}</p>
                    </Col>
                    <Col lg={4}>
                      <label>Contact Person</label>
                      <p>{this.state.contact_person}</p>
                    </Col>
                    <Col lg={4}>
                      <label>Contact No</label>
                      <p>{this.state.contact_no}</p>
                    </Col>
                    <Col lg={4}>
                      <label>Email</label>
                      <p>{this.state.email}</p>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xl={12} lg={12} md={12}>
              <Card>
                <CardBody>
                  {/* <div className="text-right mb-4">
                    <div className="ps-btn-group">
                      <Button color="link" onClick={this.toggle('ADD', null)}>
                        <IconContext.Provider value={{ color: '#2a2c6b' }}>
                          <BsPlusSquareFill size={25} />
                        </IconContext.Provider>
                      </Button>
                    </div>
                  </div> */}
                  <Table responsive hover className="ps-table tb-col-4">
                    <thead>
                      <tr>
                        <th>Product No</th>
                        <th>Product Name</th>
                        <th>Category</th>
                        <th>Product Type</th>
                        {/* <th>Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {/* {this.state.subDataList.length < 1 && (
                          <tr>
                            <td colSpan="5">
                              <div className="ps-empty-data">
                                <div className="empty-content">
                                  <MdCreate />
                                  <h4>No data to show</h4>
                                  <span>Click the 'Create' button to add new user</span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        )} */}

                      {this.state.subDataList &&
                        this.state.subDataList.length > 0 &&
                        this.state.subDataList.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>{item.product_no}</td>
                              <td>{item.name}</td>
                              <td>{item.category}</td>
                              <td>{item.product_type}</td>
                              {/* <td>
                                  <div className="ps-action-button">
                                    <Button color="link" className="theme-button theme-button-primary-light" onClick={this.toggleConfirmModal(item.name, item.user_id)}>
                                      Remove
                                    </Button>
                                  </div>
                                </td> */}
                            </tr>
                          )
                        })}
                    </tbody>
                  </Table>

                  {/* <Modal isOpen={this.state.modal} toggle={this.toggle()} className={this.props.className} centered>
                      <Form onSubmit={this.handleSubmit} className="AuthForm">
                        <ModalHeader toggle={this.toggle()}>User</ModalHeader>
                        <ModalBody>
                          <Row>
                            <Col md={12}>
                              <FormGroup>
                                <Label for="role"></Label>
                              
                                <Select options={options} name="user_id" onChange={this.selectHandler()} menuPosition={'fixed'} required />
                              </FormGroup>
                            </Col>
                          </Row>
                        </ModalBody>
                        <ModalFooter>
                          <Button className="theme-button theme-button-secondary" onClick={this.toggle()}>
                            Close
                          </Button>
                          <Button className="theme-button theme-button-primary" type="submit">
                            {this.state.isEdit ? 'Save' : 'Add'}
                          </Button>{' '}
                        </ModalFooter>
                      </Form>
                    </Modal> */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </>

        {/* <Modal isOpen={this.state.userModal} toggle={this.toggleUser()} className={this.props.className} centered>
          <PosUserForm history={this.props.history} onToggleModal={this.toggleUser} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal> */}

        {/* <Modal isOpen={this.state.confirmModal} toggle={this.toggleConfirmModal()} className={this.props.className} closeModal={this.closeModal} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleConfirmModal()}>Delete User</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to remove {this.state.selectedData} ?</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.delete()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal> */}
      </Page>
    )
  }
}
export default PosSupplierDetailPage
